export function checkNewTabButtonTarget() {
    var $btn = document.querySelectorAll("a");
    var $ww = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if ($btn.length > 0) {
        for (var i = 0; i < $btn.length; i++) {
            var $t = $btn[i],
                $href = $t.getAttribute("href");
            if ($href) {
                if ($href.includes("wa.me") || $href.includes("api.whatsapp.com/send")) {
                    $t.setAttribute("target", "_blank");
                }
            }
        }
    }
}
